import React from 'react';
import { useCaseFileStyle } from '../../context/CaseFileStyleContext';

/**
 * Lets the viewer switch between the two case-file design directions:
 * Evidence Board (kraft/exhibit tags) and Field Report (ruled grid/form fields).
 */
export const CaseFileStyleToggle: React.FC<{ compact?: boolean }> = ({ compact }) => {
  const { style, setStyle } = useCaseFileStyle();

  return (
    <div
      className="inline-flex items-center rounded-full border border-cream-300 dark:border-navy-600 bg-cream-100 dark:bg-navy-800 p-0.5 text-[9px] font-black uppercase tracking-widest"
      role="tablist"
      aria-label="Case file style"
    >
      <button
        type="button"
        role="tab"
        aria-selected={style === 'evidence-board'}
        onClick={() => setStyle('evidence-board')}
        className={`px-2.5 py-1 rounded-full transition ${
          style === 'evidence-board'
            ? 'bg-navy-900 text-cream-50 dark:bg-gold-500 dark:text-navy-900'
            : 'text-navy-400 dark:text-navy-300 hover:text-navy-600 dark:hover:text-cream-200'
        }`}
      >
        {compact ? 'Board' : 'Evidence Board'}
      </button>
      <button
        type="button"
        role="tab"
        aria-selected={style === 'field-report'}
        onClick={() => setStyle('field-report')}
        className={`px-2.5 py-1 rounded-full transition ${
          style === 'field-report'
            ? 'bg-navy-900 text-cream-50 dark:bg-gold-500 dark:text-navy-900'
            : 'text-navy-400 dark:text-navy-300 hover:text-navy-600 dark:hover:text-cream-200'
        }`}
      >
        {compact ? 'Report' : 'Field Report'}
      </button>
    </div>
  );
};
